<div class="base-card -title-container">
  <span class='-vertical-line'></span>
  <h3 class="mt-0">{{title}}</h3>
</div>
<ng-content></ng-content>
